(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-btan-reviews-okendo"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // Initialize the tabs
    $('.btan-reviews-okendo .tabs a').click(function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
 
        $('.btan-reviews-okendo .tabs .tab').removeClass('active');
        $('.btan-reviews-okendo .tab-content').removeClass('active');
        
        $(target).addClass('active');
        $(this).parent().addClass('active');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-btan-reviews-slider"] && !Shopify.designMode) return;
  try {
     


var proTestimonials = tns({ 
  container: $('.btan-reviews-slider .swiper-wrapper')[0],
  items: 1.2, 
  nav: false,
  controls: true,
  gutter: 0,  
  loop: true,
  autoHeight: false,
  mouseDrag: true,
  nextButton:  $('.btan-reviews-slider .next-control')[0],
  prevButton:  $('.btan-reviews-slider .prev-control')[0],
  swipeAngle: 60,
  autoplayButtonOutput: false, 
  autoplay: true,
  autoplayHoverPause: true,
  autoplayTimeout: 5000,
  responsive: {
    840: {
      items: 3, 
    },
    768: {
      items: 2, 
    },
    620: {
      items: 2.2, 
    },
  }
}); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-btan-testimonials"] && !Shopify.designMode) return;
  try {
    
  var btanTestimonials = tns({
    container: $('.btan-testimonials-block .swiper-wrapper')[0],
    items: 1,
    nav: true,
    controls: $('main.bfresh-main').length ? true : false,
    gutter: 0,
    loop: true,
    autoHeight: true,
    mouseDrag: true,
    responsive: {},
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-btan-tik-tok"] && !Shopify.designMode) return;
  try {
    
 if($('.btan-tiktok .tns-outer').length == 0) {
  $('.btan-tiktok .tiktok-slider').each(function() {
    // Only initialize slider if there are slides
    if($(this).find('.slide').length > 0) {
      tns({
          container: $(this)[0],
          items: 2,
          nav: false,
          controls: false,
          gutter: 32,
          center: false,
          loop: true,
          mouseDrag: true,

          responsive: {
              1280: {
                  items: 4, 
              }, 
              768: {
                  items: 3, 
              },
              480: {
                  items: 2, 
                  controls: true,
              }
          }
      }); 
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-landing-product-sticky"] && !Shopify.designMode) return;
  try {
    
  $('#add-to-cart-sticky').click(function (e) {
    e.preventDefault();
    $('#add-to-cart-form #product-add-to-cart').trigger('click');
  });
  showStickyButtons();
  $(window).scroll(function () {
    showStickyButtons();
  });
  $(window).resize(function () {
    showStickyButtons();
  });
  function showStickyButtons() {
    var scrollTop = $(window).scrollTop();
    var pos = $('.wrapper-container > section').eq(1).offset().top;
    if (pos < scrollTop) {
      $('.product-sticky-buttons').addClass('shown');
      $('body').addClass('have-bottom-sticky');
    } else {
      $('.product-sticky-buttons').removeClass('shown');
      $('body').removeClass('have-bottom-sticky');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-landing-results-block"] && !Shopify.designMode) return;
  try {
    
var l_galleryTop2, l_galleryThumbs2, l_galleryThumbs3;
jQuery(document).ready(function($) {
  l_galleryTop2 = new Swiper('.gallery-top-2', {
      spaceBetween: 10, 
  });
  l_galleryTop2.on('slideChangeTransitionEnd', function(swiper) {
    var activeIndex = l_galleryTop2.activeIndex;
    $(l_galleryThumbs2.slides).removeClass('is-selected');
    $(l_galleryThumbs2.slides).eq(activeIndex).addClass('is-selected');
    l_galleryThumbs2.slideTo(activeIndex, 500, false);
    $(l_galleryThumbs3.slides).removeClass('is-selected');
    $(l_galleryThumbs3.slides).eq(activeIndex).addClass('is-selected');
    l_galleryThumbs3.slideTo(activeIndex, 500, false);
  });
  l_galleryThumbs2 = new Swiper('.gallery-thumbs-2', {
      spaceBetween: 20,
      freeMode: true,
      centeredSlides: false,
      direction: ($('.gallery-thumbs-2').hasClass('vertical') ? 'vertical' : 'horizontal'),
      slidesPerView: 'auto',
      touchRatio: 0.2, 
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  });
  l_galleryThumbs2.on('click', function(swiper, event) {
    var clicked = l_galleryThumbs2.clickedIndex
    l_galleryThumbs2.activeIndex = clicked; //don't need this
    //l_galleryThumbs2.updateClasses() //don't need this
    $(l_galleryThumbs2.slides).removeClass('is-selected');
    $(l_galleryThumbs2.clickedSlide).addClass('is-selected');
    l_galleryTop2.slideTo(clicked,500, false);
  });
  l_galleryThumbs3 = new Swiper('.gallery-thumbs-3', {
      spaceBetween: 20,
      freeMode: true,
      centeredSlides: false,
      direction: 'horizontal',
      slidesPerView: 'auto',
      touchRatio: 0.2, 
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  });
  l_galleryThumbs3.on('click', function(swiper, event) {
    var clicked = l_galleryThumbs3.clickedIndex
    l_galleryThumbs3.activeIndex = clicked; //don't need this
    //l_galleryThumbs3.updateClasses() //don't need this
    $(l_galleryThumbs3.slides).removeClass('is-selected');
    $(l_galleryThumbs3.clickedSlide).addClass('is-selected');
    l_galleryTop2.slideTo(clicked,500, false);
  });
  $(l_galleryThumbs2.slides).eq(0).addClass('is-selected'); 
  $(l_galleryThumbs3.slides).eq(0).addClass('is-selected');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-landing-video-block"] && !Shopify.designMode) return;
  try {
         
  $('.video-landing-block .video-hold').each(function() {
      var $container = $(this);
      var $btn = $(this).find('.play-btn');
      var video = $(this).find('video')[0];
      video.onended = function() {
          $container.removeClass('playing'); 
      };

      $btn.click(function(e) {
          e.preventDefault();
          if($container.hasClass('playing')) {
              $container.removeClass('playing');
              video.pause();
          } else {
              video.play();
              $container.addClass('playing');
          }
      });
  });

  $('.video-landing-block [data-play-video-id]').click(function(e) {
    e.preventDefault();
    var id = $(this).data('play-video-id');
    $('[data-video-id="'+id+'"]').find('.play-btn').trigger('click');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bfresh"]) return;
  try {
    
  function resizeMainBlock() {
    var mainBlock = $('.main-bfresh-product');
    if (mainBlock.length) {
      var height = mainBlock.find('.product-shop-inner').innerHeight();
      mainBlock.find('.product > .row').css('min-height', height + 'px');
    }
  }
  $(document).ready(function () {
    resizeMainBlock();
    $(window).resize(function () {
      resizeMainBlock();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-btan-self-tan"]) return;
  try {
    
  function resizeMainBlock() {
    var mainBlock = $('.main-btan-product');
    if (mainBlock.length) {
      var height = mainBlock.find('.product-shop-inner').innerHeight();
      mainBlock.find('.product > .row').css('min-height', height + 'px');
    }
  }
  $(document).ready(function () {
    resizeMainBlock();
    $(window).resize(function () {
      resizeMainBlock();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
